
import { Component, Vue } from 'nuxt-property-decorator';
import App from '~/components/layout/App.vue';

@Component({
  components: {
    App,
  },
})
export default class FluidLayout extends Vue {}
